import Button from "components/button";
import { MainWrapper } from "components/main-wrapper";
import { useTranslation } from "hooks/use-translation";
import PropTypes from "prop-types";

function ServiceUnavailable({ service, onCtaClick }) {
  const { tcomponent } = useTranslation({
    component: "service-unavailable",
  });

  return (
    <MainWrapper title={tcomponent("service-not-available")}>
      <div className="w-full space-y-4">
        <p className="text-green-500 dark:text-zinc-200">
          {tcomponent("trying-to-sign-into")}
        </p>

        <p className="font-semibold text-green-500 dark:text-zinc-100">
          {tcomponent(service)}
        </p>

        <p className="mt-0 text-green-500 dark:text-zinc-200">
          {tcomponent("not-available-for-sso-identity")}
        </p>

        <p className="mt-0 text-green-500 dark:text-zinc-200">
          {tcomponent("believe-this-is-a-mistake")}
        </p>

        <Button type="submit" onClick={onCtaClick}>
          {tcomponent("back-to-login")}
        </Button>

        <div className="flex flex-row items-center justify-between gap-4">
          <a href="https://givenergy.co.uk">
            {tcomponent("givenergy-homepage")}
          </a>

          <a href="https://givenergy.co.uk/contact-us/">
            {tcomponent("contact-support")}
          </a>
        </div>
      </div>
    </MainWrapper>
  );
}

ServiceUnavailable.propTypes = {
  service: PropTypes.string.isRequired,
  onCtaClick: PropTypes.func.isRequired,
};

export default ServiceUnavailable;
